const APP_CONFIG = {
  FRONTEND_VERSION: 48,
  CLIENT_PLATFORM: "web",
};

export default APP_CONFIG;
